var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{ disabled: _vm.disabled, loading: _vm.isLoading, wicon: _vm.icon },attrs:{"type":_vm.type || 'button'},on:{"click":_vm.click}},[(_vm.icon && !_vm.isLoading)?_c('icon',{attrs:{"name":_vm.icon}}):_vm._e(),(_vm.isLoading)?[_c('loader'),_vm._v("\n    "+_vm._s(_vm.loading || '')+"\n  ")]:_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7074aee4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/globals/Btn.vue
// module id = 362
// module chunks = 8